import { render, staticRenderFns } from "./insurance_item_info.vue?vue&type=template&id=a02e0c2e&"
import script from "./insurance_item_info.vue?vue&type=script&lang=js&"
export * from "./insurance_item_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports